module.exports = "/_next/static/images/favicon-16-bcaec41cfc9939d125874b07a2d9ff63.png";